import Utils from '@/api/Utils';

import { roundDayJs, jsNativeDateToDayJs, dayJsDatetimeToString, utcDatetimeStrToDayJs } from '@/components/common/dateUtils';


const addQualityStatsToSeries = (series, t) => {
	const getQualityStatsData = item => {
		if (item.quality_stats && Object.keys(item.quality_stats).length > 0) {
			const listData = Object.entries(item.quality_stats).map(([qualityCode, count]) => ({quality: Number(qualityCode), count}));
			const sorted1 = Utils.sortArray(listData, Utils.objectFieldMultiSorter('quality'));
			const sorted2 = Utils.sortArray(sorted1, Utils.objectFieldMultiSorter('count', 'number', true));
			return sorted2.map(item => ({
				label: t('gpsFixQuality.' + item.quality),
				value: t('rovers.activeSessions.stateHistoryChart.timesLabel', item.count),
			}));
		}
		return [];
	};

	return series.map(serie => ({
		name: serie.name,
		hidden: serie.hidden,
		data: serie.data.map(item => ({
			x: item.x,
			y: item.y,
			data: getQualityStatsData(item),
		})),
	}))
}

const getAggregatedRoverStateQuality = (qualityStats, lastYValue) => {
	if (!qualityStats || Object.keys(qualityStats).length === 0) {
		return lastYValue;
	}
	const MIXED_QUALITY = 9;
	const keys = Object.keys(qualityStats);
	if (keys.length === 1) {
		return Number(keys[0]);
	}
	if (keys.length === 2) {
		let maxCount = null;
		let keysWithMaxCounts = [];
		for (let key of keys) {
			const count = qualityStats[key];
			if (maxCount == null || count > maxCount) {
				maxCount = count;
				keysWithMaxCounts = [key];
			} else if (count === maxCount) {
				keysWithMaxCounts.push(key);
			}
		}
		if (keysWithMaxCounts.length === 1) {
			return Number(keysWithMaxCounts[0]);
		}
		return lastYValue;
	}
	return MIXED_QUALITY;
}

const aggregateQualitySeriesCategories = (series, seriesStep, seriesStepUnit, minDate, maxDate) => {
	if (!series || series.length === 0) {
		return { series: [], categories: [] };
	}
	let aggregatedSeries = [];
	let roundMinDate = roundDayJs(jsNativeDateToDayJs(minDate), seriesStepUnit, seriesStep);
	const roundMaxDate = roundDayJs(jsNativeDateToDayJs(maxDate), seriesStepUnit, seriesStep);
	const aggregatedCategories = [];
	while (roundMinDate.isBefore(roundMaxDate) || roundMinDate.isSame(roundMaxDate)) {
		aggregatedCategories.push(dayJsDatetimeToString(roundMinDate));
		roundMinDate = roundMinDate.add(seriesStep, seriesStepUnit);
	}
	for (let serie of series) {
		let buckets = new Map();
		for (let point of serie.data) {
			if (!point || point.y == null) {
				continue;
			}
			let epoch = utcDatetimeStrToDayJs(point.x, 'YYYY-MM-DD HH:mm');
			epoch = roundDayJs(epoch, seriesStepUnit, seriesStep);
			const bucketKey = dayJsDatetimeToString(epoch);
			if (!buckets.has(bucketKey)) {
				buckets.set(bucketKey, {
					x: bucketKey,
					yValues: [],
					quality_stats: {},
				});
			}
			let bucket = buckets.get(bucketKey);
			if (point.quality_stats) {
				for (let key of Object.keys(point.quality_stats)) {
					const prev = bucket.quality_stats[key] || 0;
					bucket.quality_stats[key] = prev + point.quality_stats[key];
				}
			}
			if (point.y != null) {
				bucket.yValues.push(point.y);
			}
		}
		let data = [];
		for (let key of aggregatedCategories) {
			let bucket = buckets.get(key);
			if (bucket) {
				const lastYValue = bucket.yValues.length > 0 ? bucket.yValues[bucket.yValues.length - 1] : null;
				bucket.y = getAggregatedRoverStateQuality(bucket.quality_stats, lastYValue);
				delete bucket.yValues;
				data.push(bucket);
			} else {
				data.push({
					x: key,
					y: null,
					data: [],
				});
			}
		}
		aggregatedSeries.push({
			name: serie.name,
			hidden: serie.hidden,
			data,
		});
	}
	return { series: aggregatedSeries, categories: aggregatedCategories };
}


export {
	addQualityStatsToSeries,
	aggregateQualitySeriesCategories,
}
